/* eslint-disable linebreak-style */
import React, { ReactElement } from 'react';
import { Form } from 'react-bootstrap';
import { getIn, FormikProps } from 'formik';
import { Editor } from '@tinymce/tinymce-react';

type TextFieldInput = {
  formikProps: FormikProps<any>,
  fieldName: string,
  visibleName?: string,
  extraClassValues?: string,
  placeholder?: string,
  formText?: string,
  onChangeCallback?:
  (val: string) => void,
  isDisabled?: boolean,
  isPairedInput?: boolean,
}
// window.location.
const TinyMceField: React.FC<TextFieldInput> = (
  props: TextFieldInput,
): ReactElement => {
  const {
    fieldName,
    visibleName,
    extraClassValues = '',
    // @ts-ignore
    onChangeCallback,
    formikProps,
    isDisabled,
    isPairedInput,
  } = props;
  const {
    placeholder = '',
    formText = '',
  } = props;
  const {
    values,
    touched,
    errors,
    setFieldTouched,
    handleChange,
  } = formikProps;

  const isInvalid = isPairedInput
    ? getIn(errors, fieldName)
    : getIn(touched, fieldName) && getIn(errors, fieldName);

  return (
    <Form.Group controlId={fieldName} className={extraClassValues}>
      {visibleName && <Form.Label className="font-weight-bold">{visibleName}</Form.Label>}
      <Form.Control
        className="hidden d-none"
        isInvalid={isInvalid}
      />
      <Editor
        /* @ts-ignore */
        onEditorChange={(string: string, editor: Editor) => {
          handleChange({
            target: { name: fieldName, value: string },
          });
          if (onChangeCallback) {
            onChangeCallback(string);
          }
        }}
        /* @ts-ignore */
        onBlur={(string, editor) => {
          setFieldTouched(fieldName);
        }}
        disabled={isDisabled}
        value={getIn(values, fieldName) || placeholder}
        init={{
          height: 500,
          menubar: false,
          browser_spellcheck: true,
          contextmenu: false,
          plugins: 'searchreplace wordcount',
          toolbar: 'undo redo | bold italic removeformat',
          content_css: '/css/wysiwyg.css',
          skin: false,
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        }}
      />
      <Form.Text className="text-muted">
        {formText}
      </Form.Text>
      <Form.Control.Feedback type="invalid">
        {getIn(errors, fieldName)}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

TinyMceField.defaultProps = {
  isDisabled: false,
};

export default TinyMceField;
